export default (fn, length) => Array.from({ length }, (_, i) => fn(i))
